import { TimePicker as GammaTimePicker } from '@factorialco/deprecated-design-system'

import {
  RegexFor12H,
  RegexFor24H,
  get12HFormat,
  get24HFormat,
  getStringValueWithMeridiem,
  getStringValueWithoutMeridiem,
} from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

type TimePickerProps = React.ComponentProps<typeof GammaTimePicker>

type Props = Omit<
  TimePickerProps,
  | 'selectValue'
  | 'missingLabel'
  | 'get12HFormat'
  | 'get24HFormat'
  | 'getStringValueWithoutMeridiem'
  | 'getStringValueWithMeridiem'
  | 'regexFor12H'
  | 'regexFor24H'
> & {
  missingLabel?: string
}

const TimePicker = ({ missingLabel, ...props }: Props) => (
  <GammaTimePicker
    {...props}
    missingLabel={missingLabel ?? i18n.t('common.missing_field')}
    selectValue={i18n.t('common.select')}
    get12HFormat={get12HFormat}
    get24HFormat={get24HFormat}
    getStringValueWithoutMeridiem={getStringValueWithoutMeridiem}
    getStringValueWithMeridiem={getStringValueWithMeridiem}
    regexFor12H={RegexFor12H}
    regexFor24H={RegexFor24H}
  />
)

export default TimePicker
